<template>
  <v-divider></v-divider>
</template>

<script>
export default {
  name: 'DividerWidget',
  data() {
    return {}
  }
}
</script>
